import { render } from "./HeatingOfLenta.vue?vue&type=template&id=6bf21585&scoped=true"
import script from "./HeatingOfLenta.vue?vue&type=script&lang=js"
export * from "./HeatingOfLenta.vue?vue&type=script&lang=js"

import "./HeatingOfLenta.vue?vue&type=style&index=0&id=6bf21585&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf21585"]])

export default __exports__